import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "conditions-content" }
const _hoisted_3 = { class: "conditions-options" }
const _hoisted_4 = { class: "conditions-grid" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "condition-badge" }
const _hoisted_7 = {
  key: 0,
  class: "current-indicator"
}
const _hoisted_8 = {
  key: 1,
  class: "checkmark"
}
const _hoisted_9 = { class: "modal-actions" }
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    onClose: $setup.close
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("div", { class: "modal-title" }, "Conditions")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "label" }, "Select Condition", -1)),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.allOptions, (condition) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["condition-option", { selected: $setup.selectedCondition === condition, 'current disabled': $props.currentCondition === condition }]),
                  key: condition,
                  onClick: ($event: any) => ($setup.selectCondition(condition))
                }, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(condition), 1),
                  ($props.currentCondition === condition)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Current"))
                    : _createCommentVNode("", true),
                  ($setup.selectedCondition === condition)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, "✓"))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_5))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "btn cancel",
            onClick: $setup.close
          }, "Cancel"),
          _createElementVNode("button", {
            class: "btn primary v2",
            onClick: $setup.confirm,
            disabled: !$setup.selectedCondition || $setup.selectedCondition === $props.currentCondition
          }, "Done", 8, _hoisted_10)
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}